import Request from "./request";

export default class ShareLinksService {
  static async create(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/ShareLinks/advanceUser/create",
        data,
      }).then((result) => {
        return resolve({ isSuccess: result.statusCode === 200, ...result });
      });
    });
  }
  static async update(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/ShareLinks/advanceUser/updateById",
        data,
      }).then((result) => {
        return resolve({ isSuccess: result.statusCode === 200, ...result });
      });
    });
  }
}
